import { submissionsApi } from '@api';
import { IChangeSubmissionStatusDto, ISubmission } from '@app-types';
import { UseMutationOptions, useMutation } from '@tanstack/react-query';

const useChangeSubmissionStatusByCustomer = (
  id: string | undefined,
  options?: UseMutationOptions<ISubmission, unknown, IChangeSubmissionStatusDto>,
) => {
  return useMutation({
    ...options,
    mutationFn: (data) => {
      return submissionsApi.changeSubmissionStatusByCustomer({ id, data });
    },
  });
};

export default useChangeSubmissionStatusByCustomer;
